import { render, staticRenderFns } from "./BranchHumanResourcesAssignView.vue?vue&type=template&id=73c42a20&"
import script from "./BranchHumanResourcesAssignView.vue?vue&type=script&lang=js&"
export * from "./BranchHumanResourcesAssignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports